import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { AdministratorService } from '../../../../services/administrator.service';
import { CommonModule } from '@angular/common';
import { gridPageRequest, GSTInfo } from '../../../../model/common/common.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import _ from 'lodash';
import { LoaderComponent } from '../../../loader/loader.component';
import { Table } from 'primeng/table';
import { getISTDateWithCurrentTime } from '../../../../utils/date-utils';

@Component({
  selector: 'app-gst-list',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './gst-list.component.html',
  styleUrl: './gst-list.component.scss'
})
export class GstListComponent implements OnInit {

  constructor(private administratorService: AdministratorService, private messageService: MessageService, private confirmationService: ConfirmationService) { }
  @ViewChild('dt1') dt1: Table | undefined;

  visible: boolean = false;
  warn: boolean = false;
  loader: boolean = false;
  isEdit: boolean = false;
  searchKey: any;
  submitted: boolean = false;
 allHSNCodes: any[] = []; // Full HSN list
  filteredHSNCodes: any[] = [];
  gstList: GSTInfo[] = [];
  selectedGST: GSTInfo[] = [];

  createGSTForm = new FormGroup({
    GSTId: new FormControl(0),
    HSNCode: new FormControl('', Validators.required),
    GSTDescription: new FormControl('', Validators.required),
    GSTRate: new FormControl('', Validators.required),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    EffectiveFrom: new FormControl(new Date(), Validators.required),
IsServiceType: new FormControl<boolean | null>(null, Validators.required),  });

  ngOnInit(): void {
    document.title = 'GST List';
    this.getGSTList();
    this.searchEffect();
    this.createGSTForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
  }
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }
  getGSTList() {
    this.loader = true
    this.administratorService.getAllGST(this.pageRequest).subscribe(
      (data: any) => {
        if (data) {
          this.gstList = data.gst;
          this.loader = false;
        } else {
          console.log(data);
          this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  open() {
    this.visible = true;
    this.isEdit = false;
    this.createGSTForm.controls.GSTId.disable();
    this.createGSTForm.patchValue({
        EffectiveFrom: new Date()
    });
    this.showDialog();
  }

  showDialog() {
    this.createGSTForm.reset();
    this.createGSTForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
  }
cancelDialog() {
  this.visible = false;

  // reset flags
  this.warn = false;
  this.submitted = false;
  this.isEdit = false;

  // reset form
  this.createGSTForm.reset();
  this.createGSTForm.enable();

  // reset defaults
  this.createGSTForm.patchValue({
    EffectiveFrom: new Date(),
    CreatedBy: localStorage.getItem('username')
  });

  // clear selection & reload table
  this.selectedGST = [];
  this.getGSTList();
}

createGST() {
  if (this.createGSTForm.invalid) {
    this.warn = true;
       this.submitted = true;

    this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill all fields' });
    return;
  }

  this.loader = true;
  const payload = { ...this.createGSTForm.value };

if (payload.EffectiveFrom) {
  const istString = getISTDateWithCurrentTime(payload.EffectiveFrom);
  if (istString) {
    const date = new Date(istString);
    const istOffsetMs = 5.5 * 60 * 60 * 1000; 
    payload.EffectiveFrom = new Date(date.getTime() + istOffsetMs);
  } else {
    payload.EffectiveFrom = null;
  }
} else {
  payload.EffectiveFrom = null;
}

  this.administratorService.createGST(payload).subscribe(
    (data: any) => {
      if (data.success === true) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
        this.visible = false;
        this.loader = false;
        this.showDialog();
        this.getGSTList();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        this.loader = false;
      }
    },
    (error: any) => {
      console.log(error);
      this.loader = false;
    }
  );
}

  delete() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;
        var gstId = _.map(this.selectedGST, 'gstId');

        this.administratorService.deleteGST(gstId).subscribe({
          next: (data: any) => {
            if (data.success === true) {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
              this.loader = false;
              this.selectedGST = [];
              this.getGSTList();
            } else {
              this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
              this.loader = false;
            }
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        });
      },
      reject: () => {
      }
    });

  }

 edit(data?: any) {
  this.visible = true;
  this.isEdit = true; // mark edit mode

  if (data) {
    const firstSelectedGST = data;

    this.createGSTForm.patchValue({
      HSNCode: firstSelectedGST.hsnCode,
      GSTId: firstSelectedGST.gstId,
      GSTDescription: firstSelectedGST.gstDescription,
      GSTRate: _.toString(firstSelectedGST.gstRate),
      UpdatedBy: localStorage.getItem('username'),
      EffectiveFrom: firstSelectedGST.effectiveFrom ? new Date(firstSelectedGST.effectiveFrom) : null,
      IsServiceType: firstSelectedGST.isServiceType||false // assign boolean value
    });
  }

  // Disable the Type radio FormControl in edit mode
  this.createGSTForm.get('IsServiceType')?.disable();
}



update() {
  if (this.createGSTForm.invalid) {
    this.warn = true;
    this.messageService.add({
      severity: 'error',
      summary: 'Warning',
      detail: 'Please fill all field'
    });
    return;
  }

  // ensure HSN is string
  let hsn = this.createGSTForm.controls.HSNCode.value;
  this.createGSTForm.controls.HSNCode.setValue(_.toString(hsn));

  this.loader = true;

  const payload = this.createGSTForm.getRawValue();

  if (payload.EffectiveFrom) {
    const istString = getISTDateWithCurrentTime(payload.EffectiveFrom);
    if (istString) {
      const date = new Date(istString);
      const istOffsetMs = 5.5 * 60 * 60 * 1000;
      payload.EffectiveFrom = new Date(date.getTime() + istOffsetMs);
    } else {
      payload.EffectiveFrom = null;
    }
  } else {
    payload.EffectiveFrom = null;
  }

  this.administratorService.updateGST(payload).subscribe(
    (data: any) => {
      if (data.success === true) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data.message
        });
        this.visible = false;
        this.selectedGST = [];
        this.showDialog();
        this.getGSTList();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: data.message
        });
      }
      this.loader = false;
    },
    (error: any) => {
      console.log(error);
      this.loader = false;
    }
  );
}

  searchGST() {
    if (!this.searchKey) {
      return;
    }

    this.administratorService.autoSearchGST(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.gstList = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }

        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  loadGST(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      // this.searchGST();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getGSTList();
    }
  }
  
  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getGSTList();
  }

  
  placeholder: string = 'Search By ';
  private messages: string[] = ['HSN Code', 'Description Goods'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
  get formControls() {
  return this.createGSTForm.controls;
}


}
